import React, { useEffect, useState } from 'react';
import { ZapIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../data/content';

/**
 * Sticky bottom CTA that appears once the user scrolls past the first CTA button.
 */
export function FloatingCTA() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const anchor = document.getElementById('hero-cta');
    if (!anchor) return;
    const observer = new IntersectionObserver(([entry]) => {
      const scrolledPast = entry.boundingClientRect.top < 0;
      setVisible(!entry.isIntersecting && scrolledPast);
    }, {
      threshold: 0
    });
    observer.observe(anchor);
    return () => observer.disconnect();
  }, []);
  return <div className={`fixed inset-x-0 bottom-0 z-40 border-t border-gold-600/40 bg-ink-950/95 px-3 pb-[max(0.75rem,env(safe-area-inset-bottom))] pt-3 backdrop-blur transition-[transform,opacity] duration-200 ease-out ${visible ? 'translate-y-0 opacity-100' : 'pointer-events-none translate-y-full opacity-0'}`} data-id="element-30" data-mp="2awcxi83qmwuf">
      <div className="mx-auto flex max-w-xl items-center gap-3" data-id="element-31" data-mp="2z4bmz44oa1oj">
        <div className="hidden min-w-0 flex-1 sm:block" data-id="element-32" data-mp="3329faftqp3w5">
          <p className="font-display text-base font-bold uppercase leading-tight text-white" data-id="element-33" data-mp="2pce7vmajmpkj">
            Premium Technician Kit™
          </p>
          <p className="text-xs font-semibold text-gold-400" data-id="element-34" data-mp="2u9o7tvvk6jmm">
            $27 USD · One-time payment
          </p>
        </div>
        <a href={CHECKOUT_URL} className="flex flex-1 animate-shake items-center justify-center gap-2 rounded-xl bg-gold-500 px-4 py-3.5 font-display text-lg font-extrabold uppercase tracking-wide text-ink-950 shadow-[0_5px_0_0_#A96B02] transition-[transform,background-color] duration-150 ease-out hover:bg-gold-400 active:translate-y-[2px] focus:outline-none focus-visible:ring-4 focus-visible:ring-gold-400/60 sm:flex-none" data-id="element-35" data-mp="2fgb9mritbb2v">
          <ZapIcon className="h-5 w-5 shrink-0" aria-hidden="true" data-id="element-36" data-mp="9jyr1dbaonra" />
          Get it now — $27
        </a>
      </div>
    </div>;
}